module.exports = __webpack_public_path__ + "static/media/ieee_logo.1618d0de.webp";